import { useEffect, useContext } from "react"
import * as Yup from "yup"
import GenericAssetForm from "./common/GenericAssetForm"
import { useFormikContext } from "formik"

// Collectibles initial values
export const collectiblesInitialValues = {
  categoryType: "",
  description: "",
  estimatedCurrentValue: "",
  sourceSeller: "",
  ownershipType: "",
}

// Collectibles validation schema
export const collectiblesValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Collectible Name is required")
    .min(3, "Min length: 3 characters")
    .max(50, "Max length: 50 characters")
    .matches(
      /^(?! )[A-Za-z0-9\-_.&()]+( [A-Za-z0-9\-_.&()]+)*(?<! )$/,
      "Allowed: letters, numbers, -, _, &, ., (, ). No leading/trailing/blank spaces."
    ),
  categoryType: Yup.string().required("Category / Type is required"),
  // description: Yup.string().required("Description is required"),
  estimatedCurrentValue: Yup.number()
    .typeError("Must be a positive number")
    .required("Estimated Current Value is required")
    .positive("Must be a positive number > 0")
    .min(0.01, "Must be greater than 0"),
  ownershipType: Yup.string().required("Ownership Type is required"),
  purchasePrice: Yup.number()
    .typeError("Must be a positive number")
    .required("Purchase Price is required")
    .positive("Must be a positive number > 0")
    .min(0.01, "Must be greater than 0"),
  purchaseCurrency: Yup.string().required("Currency is required"),
})

/**
 * Collectibles Form - Field-only component for AddAssets.js
 * This renders only the collectibles-specific fields without form wrapper
 * Used in ADD mode within AddAssets.js's existing Formik wrapper
 */
const CollectiblesForm = ({ values, setFieldValue, errors, touched, defaultCurrency }) => {
  const { setFieldTouched } = useFormikContext() || {}
  
  // Handle default currency setting
  useEffect(() => {
    if ((!values.purchaseCurrency || values.purchaseCurrency === "") && defaultCurrency) {
      setFieldValue("purchaseCurrency", defaultCurrency)
    }
  }, [values.purchaseCurrency, defaultCurrency, setFieldValue])

  return (
    <GenericAssetForm
      subCategory="collectibles"
      values={values}
      setFieldValue={setFieldValue}
      setFieldTouched={setFieldTouched}
      errors={errors}
      touched={touched}
      defaultCurrency={defaultCurrency}
      readOnly={false}
    />
  )
}

export default CollectiblesForm
